import {NavLink, useLocation} from 'react-router';
import {tr} from '../i18n/idioma';
import {ve} from './areas';
import {useUsuario} from './sesion-contexto';

// Subsecciones del inventario (menu nuevo, 6/10/2026): la tabla, Mineros y
// las recolecciones. Las reservas pasaron a Exportaciones y los reportes a
// Analisis. Los filtros de la tabla viajan en la direccion; Mineros y las
// recolecciones tienen los suyos y no se cruzan.
export function PestanasInventario() {
  const {search, pathname} = useLocation();
  const busquedaPara = (a: string) => (a === pathname ? search : '');
  const pestanas = [
    // "Consolidado" (Daniel, 6/10/2026): la tabla de todos los Big Bags, como el Consolidated Shipments.
    {a: '/inventario', texto: tr('Consolidado', 'Consolidated'), area: 'inventario.consolidado'},
    {a: '/inventario/mineros', texto: tr('Mineros', 'Mineros'), area: 'inventario.mineros'},
    {a: '/inventario/recolecciones', texto: tr('Recolecciones', 'Pickups'), area: 'inventario.recolecciones'},
  ];
  return (
    <Pestanas
      pestanas={pestanas}
      busquedaPara={busquedaPara}
      nombre={tr('Secciones del inventario', 'Inventory sections')}
    />
  );
}

// Pestanas comunes de las secciones: una barra con la subrayada activa. Solo
// salen las que la persona ve (decision 0062).
export function Pestanas({
  pestanas,
  nombre,
  busquedaPara = () => '',
}: {
  pestanas: Array<{a: string; texto: string; area?: string}>;
  nombre: string;
  busquedaPara?: (a: string) => string;
}) {
  const usuario = useUsuario();
  return (
    <nav className="flex flex-wrap gap-1 border-b border-linea" aria-label={nombre}>
      {pestanas
        .filter(p => !p.area || ve(usuario, p.area))
        .map(p => (
          <NavLink
            key={p.a}
            to={{pathname: p.a, search: busquedaPara(p.a)}}
            end
            className={({isActive}) =>
              `-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
                // Tema Sun Valley: la pestana activa lleva subrayado de oro.
                isActive ? 'border-dorado text-verde-oscuro' : 'border-transparent text-apagado hover:text-tinta'
              }`
            }
          >
            {p.texto}
          </NavLink>
        ))}
    </nav>
  );
}
